<template>
  <component
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view></router-view>
    </transition>

    <!-- Outside the router-view: a pending update must stay visible across
         navigation, since an SPA route change never reloads the page. -->
    <app-update-notice />
  </component>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'

// Layouts
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import LayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'
import LayoutZero from '@/layouts/variants/blank/LayoutZero.vue'

// Dynamic vh
import useDynamicVh from '@core/utils/useDynamicVh'

import { loadLanguageAsync } from '@/plugins/i18n'

import AppUpdateNotice from '@/components/AppUpdateNotice.vue'

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    LayoutBlank,
    LayoutZero,
    AppUpdateNotice,
  },
  mounted() {
    const sessionData = localStorage.getItem('session') || sessionStorage.getItem('session')
    const localeData = sessionStorage.getItem('locale')
    if (sessionData) {
      const sessionDataParsed = JSON.parse(sessionData)

      sessionDataParsed.alreadyLoaded = true
      this.$store.dispatch('session/setSessionData', sessionDataParsed)
    }

    if(localeData) {
      loadLanguageAsync(localeData)
    }
  },
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`
      if (route.value.meta.layout === 'zero') return 'layout-zero'

      return null
    })

    useDynamicVh()

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
}
</script>
